import Axios from '@/axios';

// 预警查询
export const getWarnings = params => {  
  return Axios({
    url: '/face/web/warning/index_warning',
    method: 'GET',
    type: 'json',
    params
  })
}